import { UserDTO } from "groopit-js";
import {
  AssignmentDTO,
  ComponentOperationType,
  DatePickerRangeDTO,
  FeedFilterDataTypes,
} from "groopit-js/client";
import { GroopitFilter } from "../GroopitFilterDTO";

export interface FilterAddCreatorAction {
  type: "addCreator";
  creator: UserDTO;
  assignment?: AssignmentDTO;
}
export const FilterAddCreatorActionType = "addCreator";
export const createFilterAddCreatorAction = (
  creator: UserDTO,
  assignment?: AssignmentDTO,
): FilterAddCreatorAction => ({
  type: FilterAddCreatorActionType,
  creator,
  assignment,
});

export interface FilterRemoveCreatorAction {
  type: "removeCreator";
  creatorId: string;
  assignmentId?: string;
}
export const FilterRemoveCreatorActionType = "removeCreator";
export const createFilterRemoveCreatorAction = (
  creatorId: string,
  assignmentId?: string,
): FilterRemoveCreatorAction => ({
  type: FilterRemoveCreatorActionType,
  creatorId,
  assignmentId,
});

export interface FilterReplaceCreatorsAction {
  type: "replaceCreators";
  creators: UserDTO[];
  assignment?: AssignmentDTO;
}
export const FilterReplaceCreatorsActionType = "replaceCreators";
export const createFilterReplaceCreatorsAction = (
  creators: UserDTO[],
  assignment?: AssignmentDTO,
): FilterReplaceCreatorsAction => ({
  type: FilterReplaceCreatorsActionType,
  creators,
  assignment,
});

export interface FilterAddDateRangeAction {
  type: "addDateRange";
  dateRange: DatePickerRangeDTO;
  assignment?: AssignmentDTO;
}
export const FilterAddDateRangeActionType = "addDateRange";
export const createFilterAddDateRangeAction = (
  dateRange: DatePickerRangeDTO,
  assignment?: AssignmentDTO,
): FilterAddDateRangeAction => ({
  type: FilterAddDateRangeActionType,
  dateRange,
  assignment,
});

export interface FilterRemoveDateRangeAction {
  type: "removeDateRange";
  assignmentId?: string;
}
export const FilterRemoveDateRangeActionType = "removeDateRange";
export const createFilterRemoveDateRangeAction = (
  assignmentId?: string,
): FilterRemoveDateRangeAction => ({
  type: FilterRemoveDateRangeActionType,
  assignmentId,
});

export interface FilterAddKeywordQueryAction {
  type: "addKeywordQuery";
  query: string;
}
export const FilterAddKeywordQueryActionType = "addKeywordQuery";
export const createFilterAddKeywordQueryAction = (
  query: string,
): FilterAddKeywordQueryAction => ({
  type: FilterAddKeywordQueryActionType,
  query,
});

export interface FilterRemoveKeywordQueryAction {
  type: "removeKeywordQuery";
  query: string;
}
export const FilterRemoveKeywordQueryActionType = "removeKeywordQuery";
export const createFilterRemoveKeywordQueryAction = (
  query: string,
): FilterRemoveKeywordQueryAction => ({
  type: FilterRemoveKeywordQueryActionType,
  query,
});

export interface FilterReplaceKeywordQueryAction {
  type: "replaceKeywordQuery";
  keywords: string[];
}
export const FilterReplaceKeywordQueryActionType = "replaceKeywordQuery";
export const createFilterReplaceKeywordQueryAction = (
  keywords: string[],
): FilterReplaceKeywordQueryAction => ({
  type: FilterReplaceKeywordQueryActionType,
  keywords,
});

export interface FilterRemoveTagAction {
  type: "removeTag";
  tag: string;
}
export const FilterRemoveTagActionType = "removeTag";
export const createFilterRemoveTagAction = (
  tag: string,
): FilterRemoveTagAction => ({
  type: FilterRemoveTagActionType,
  tag,
});

export interface FilterRemoveChoiceAction {
  type: "removeChoice";
  choice: string;
}
export const FilterRemoveChoiceActionType = "removeChoice";
export const createFilterRemoveChoiceAction = (
  choice: string,
): FilterRemoveChoiceAction => ({
  type: FilterRemoveChoiceActionType,
  choice,
});

export interface FilterRemoveDataTypeAction {
  type: "removeDataType";
  dataType: FeedFilterDataTypes;
}
export const FilterRemoveDataTypeActionType = "removeDataType";
export const createFilterRemoveDataTypeAction = (
  dataType: FeedFilterDataTypes,
): FilterRemoveDataTypeAction => ({
  type: FilterRemoveDataTypeActionType,
  dataType,
});

export interface FilterAddAssignmentAction {
  type: "addAssignment";
  assignment: AssignmentDTO;
}
export const FilterAddAssignmentActionType = "addAssignment";
export const createFilterAddAssignmentAction = (
  assignment: AssignmentDTO,
): FilterAddAssignmentAction => ({
  type: FilterAddAssignmentActionType,
  assignment,
});

export interface FilterRemoveAssignmentAction {
  type: "removeAssignment";
  assignmentId: string;
}
export const FilterRemoveAssignmentActionType = "removeAssignment";
export const createFilterRemoveAssignmentAction = (
  assignmentId: string,
): FilterRemoveAssignmentAction => ({
  type: FilterRemoveAssignmentActionType,
  assignmentId,
});

export interface FilterUpdateComponentAction {
  type: "updateComponent";
  componentId: number;
  assignment: AssignmentDTO;
  operation: ComponentOperationType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
}
export const FilterUpdateComponentActionType = "updateComponent";
export const createFilterUpdateComponentAction = (
  componentId: number,
  assignment: AssignmentDTO,
  operation: ComponentOperationType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any,
): FilterUpdateComponentAction => ({
  type: FilterUpdateComponentActionType,
  componentId,
  assignment,
  operation,
  value,
});

export interface FilterRemoveComponentAction {
  type: "removeComponent";
  componentId: number;
  assignmentId: string;
}
export const FilterRemoveComponentActionType = "removeComponent";
export const createFilterRemoveComponentAction = (
  componentId: number,
  assignmentId: string,
): FilterRemoveComponentAction => ({
  type: FilterRemoveComponentActionType,
  componentId,
  assignmentId,
});

export interface FilterIncludeComponentInAIAction {
  type: "includeComponentInAI";
  componentId: number;
  assignmentId: string;
}
export const FilterIncludeComponentInAIActionType = "includeComponentInAI";
export const createFilterIncludeComponentInAIAction = (
  componentId: number,
  assignmentId: string,
): FilterIncludeComponentInAIAction => ({
  type: FilterIncludeComponentInAIActionType,
  componentId,
  assignmentId,
});

export interface FilterExcludeComponentFromAIAction {
  type: "excludeComponentFromAI";
  componentId: number;
  assignment: AssignmentDTO;
}
export const FilterExcludeComponentFromAIActionType = "excludeComponentFromAI";
export const createFilterExcludeComponentFromAIAction = (
  componentId: number,
  assignment: AssignmentDTO,
): FilterExcludeComponentFromAIAction => ({
  type: FilterExcludeComponentFromAIActionType,
  componentId,
  assignment,
});

export interface FilterReplaceFilterAction {
  type: "replaceFilter";
  filter: GroopitFilter;
}
export const FilterReplaceFilterActionType = "replaceFilter";
export const createFilterReplaceFilterAction = (
  filter: GroopitFilter,
): FilterReplaceFilterAction => ({
  type: FilterReplaceFilterActionType,
  filter,
});

export interface FilterResetFilterAction {
  type: "resetFilter";
}
export const FilterResetFilterActionType = "resetFilter";
export const createFilterResetFilterAction = (): FilterResetFilterAction => ({
  type: FilterResetFilterActionType,
});

export type FilterActions =
  | FilterAddCreatorAction
  | FilterRemoveCreatorAction
  | FilterReplaceCreatorsAction
  | FilterAddDateRangeAction
  | FilterRemoveDateRangeAction
  | FilterAddKeywordQueryAction
  | FilterRemoveKeywordQueryAction
  | FilterReplaceKeywordQueryAction
  | FilterRemoveTagAction
  | FilterRemoveChoiceAction
  | FilterRemoveDataTypeAction
  | FilterAddAssignmentAction
  | FilterRemoveAssignmentAction
  | FilterUpdateComponentAction
  | FilterRemoveComponentAction
  | FilterIncludeComponentInAIAction
  | FilterExcludeComponentFromAIAction
  | FilterReplaceFilterAction
  | FilterResetFilterAction;
